import React from 'react';

import { CampaignsCarousel } from '../components/campaignsCarousel';
import { useCampaignsCarouselData } from './useCampaignsCarouselData';
import { ActiveFeature } from '../../campaigns/grid/context/useGridLayoutContextValue';

export interface CarouselsComponents {
    newDeals: React.ReactNode;
    leavingSoon: React.ReactNode;
}

export const useGetCampaignsCarousel = (activeFeature: ActiveFeature): CarouselsComponents => {
    const carouselsData = useCampaignsCarouselData();

    return {
        newDeals:
            activeFeature === 'newDeals' && carouselsData.newDeals ? (
                <CampaignsCarousel activeFeature="newDeals" />
            ) : null,
        leavingSoon:
            activeFeature === 'leavingSoon' && carouselsData.leavingSoon ? (
                <CampaignsCarousel activeFeature="leavingSoon" />
            ) : null,
    };
};
